import { useCallback, useEffect, useState } from "react";
import { RefreshCw, ShieldQuestion } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const Captcha = ({ value, onChange, nonce = 0, testPrefix = "captcha" }) => {
  const [question, setQuestion] = useState("");

  const load = useCallback(async () => {
    const { data } = await api.get("/captcha");
    setQuestion(data.question);
    onChange({ id: data.id, answer: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    load();
  }, [load, nonce]);

  return (
    <div className="rounded-2xl border border-purple-500/40 bg-purple-500/5 p-4 flex flex-wrap items-center gap-3" data-testid={`${testPrefix}-box`}>
      <ShieldQuestion className="h-5 w-5 text-purple-500" />
      <span className="font-semibold text-sm" data-testid={`${testPrefix}-question`}>{question || "Loading..."}</span>
      <Input
        data-testid={`${testPrefix}-answer-input`}
        className="w-24 rounded-xl"
        inputMode="numeric"
        value={value?.answer || ""}
        onChange={(e) => onChange({ ...value, answer: e.target.value })}
        placeholder="Answer"
      />
      <button type="button" onClick={load} data-testid={`${testPrefix}-refresh-button`} className="h-9 w-9 grid place-items-center rounded-full hover:bg-secondary transition-colors" aria-label="New question">
        <RefreshCw className="h-4 w-4" />
      </button>
    </div>
  );
};
